var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "player-container" }, [
    _c("div", { staticClass: "poster" }, [
      _c("img", { attrs: { src: _vm.player.icon, alt: "logo" } })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      false ? _c("p", [_vm._v("姓名：" + _vm._s(_vm.player.name))]) : _vm._e(),
      _vm._v(" "),
      _c("p", [_vm._v("题目：" + _vm._s(_vm.subjectTitle))]),
      _vm._v(" "),
      _c("p", [_vm._v("地点：" + _vm._s(_vm.address))])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46816d97", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46816d97","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/player-download/index.vue
// module id = null
// module chunks = 